import type { ClassDictionnary } from "@/themes/types";

export const toastIconColors: ClassDictionnary = {
	blue: "text-blue-400",
	navy: "text-navy-400",
	gray: "text-gray-400",
	green: "text-green-400",
	red: "text-red-400",
	yellow: "text-yellow-400",
};
